import React from 'react';

export interface FeedTemplateFormProps {
  property?: boolean;
}

export interface FeedTemplateFormState {
  state: boolean;
}

export default class FeedTemplateForm extends React.Component<
  FeedTemplateFormProps,
  FeedTemplateFormState
> {
  public readonly state: FeedTemplateFormState = { state: false };

  constructor(props: FeedTemplateFormProps) {
    super(props);
  }

  public render() {
    return <div />;
  }
}
